@if (isNewUI()) {
    <div
        class="campaigns"
        uiSize="md">
        <p class="text">
            Publish latest changes in selected
            {{ creatives.length > 1 ? 'creatives (' + creatives.length + ')' : 'creative' }} to the
            following {{ campaigns.length > 1 ? 'campaigns' : 'campaign' }}?
        </p>

        @for (campaign of campaigns; track campaign.id) {
            <a
                class="link"
                [href]="getCampaignLink(campaign.id)"
                target="_blank"
                [uiTooltip]="'Open campaign in a new tab'">
                {{ campaign.name }}
            </a>
        }
        <ui-banner type="neutral">Note! This action will affect live ads instantly.</ui-banner>
    </div>

    @if (hasHeavyAssets()) {
        <ui-banner type="error">
            Cannot push changes. The following files are too heavy: {{ heavyFileNames() }}
        </ui-banner>
    }

    <div class="buttons">
        <ui-button
            text="Cancel"
            (click)="cancel()"
            size="sm"
            type="solid-secondary" />

        <ui-button
            id="push-changes-dialog-confirm"
            type="solid-primary"
            svgIcon="campaigns-s"
            size="sm"
            [disabled]="hasHeavyAssets()"
            nuiSvgIcon="rocket_launch"
            [text]="'Push Changes (' + creatives.length + ')'"
            (click)="publishChanges()" />
    </div>
} @else {
    <div class="campaigns">
        <div class="text">
            Publish latest changes in selected
            {{ creatives.length > 1 ? 'creatives (' + creatives.length + ')' : 'creative' }} to the
            following {{ campaigns.length > 1 ? 'campaigns' : 'campaign' }}?
        </div>

        @for (campaign of campaigns; track campaign.id) {
            <div class="campaign">
                <a
                    class="link"
                    [href]="getCampaignLink(campaign.id)"
                    target="_blank"
                    [uiTooltip]="'Open campaign in a new tab'">
                    <ui-svg-icon icon="campaigns-s" /> {{ campaign.name }}
                </a>
            </div>
        }

        <div class="text bottom">Note! This action will affect live ads instantly.</div>
    </div>

    @if (hasHeavyAssets()) {
        <div class="error-box">
            Cannot push changes. The following files are too heavy: {{ heavyFileNames() }}
        </div>
    }

    <ui-dialog-buttons>
        <ui-button
            text="Cancel"
            (click)="cancel()" />

        <ui-button
            id="push-changes-dialog-confirm"
            type="primary"
            [disabled]="hasHeavyAssets()"
            [text]="'Push Changes (' + creatives.length + ')'"
            (click)="publishChanges()" />
    </ui-dialog-buttons>
}
